 /*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(document).ready(function() {

  // 1. Define the main initialization function
  function initPickers() {
    
    // Initialize Timepicker FIRST so its data object exists for the Datepicker
    $("#pickup-time").timepicker({
      timeFormat: 'h:mm p',
      interval: 30,
      minTime: '9:00am',
      maxTime: '5:00pm',
      defaultTime: '11:00am',
      startTime: '9:00am',
      dynamic: false,
      dropdown: true,
      scrollbar: true
    });

    // Initialize Datepicker
    $("#pickup-date").datepicker({
      minDate: 0,
      beforeShowDay: function(day) {
        var dayOfWeek = day.getDay();
        // Disable Sunday (0) and Monday (1)
        if (dayOfWeek == 0 || dayOfWeek == 1) {
          return [false];
        } else {
          return [true];
        }
      },
      onClose: function(dateText) {
        if (dateText !== '') {
          let selectedDate = new Date(dateText);
          let timePickerData = $("#pickup-time").data('TimePicker');
          
          // Safety check: ensure timepicker data exists before manipulating it
          if (timePickerData) {
            if (selectedDate.getDay() > 1 && selectedDate.getDay() < 6) {
              timePickerData.options.minTime = '10:30am';
              timePickerData.options.startTime = '10:30am';
              timePickerData.options.maxTime = '5:30pm';
              timePickerData.items = null;
              timePickerData.widget.instance = null;
              $("#pickup-time").val('');
            } else {
              timePickerData.options.minTime = '9:00am';
              timePickerData.options.startTime = '9:00am';
              timePickerData.options.maxTime = '5:00pm';
              timePickerData.items = null;
              timePickerData.widget.instance = null;
              $("#pickup-time").val('');
            }
          }
        }
      }
    });
  }

  // 2. Safe-loading Guard: Check if timepicker plugin is missing
  if (typeof $.fn.timepicker === 'undefined') {
    // Dynamically load the CDN version if it wasn't included in the theme
    $.getScript('https://cdnjs.cloudflare.com/ajax/libs/jquery-timepicker/1.13.18/jquery.timepicker.min.js', function() {
      initPickers();
    });
  } else {
    // If it's already loaded by the theme, just run it
    initPickers();
  }

});